module.exports = __webpack_public_path__ + "static/media/Driver_Image.38e81660.png";